import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Item from "./Item";

class BuyBoxWidget extends React.Component {
    constructor(props){
        super(props);

        let initialFilters = props.filters;
        let initialFilterGroups = props.filterGroups;

        this.state = {
            product: null,
            seller: {},
            filters: initialFilters,
            filterGroups: initialFilterGroups,
            isLoading: true
        };

        this.fetchData = this.fetchData.bind(this);
        this.fetchRelatingData = this.fetchRelatingData.bind(this);
    }
    fetchData(){
        let query = "";

        if(Object.values(this.state.filters).length > 0 || this.props.search){
            if (this.state.filters){
                query += `filters=${JSON.stringify(this.state.filters)}&`;
            }
            if (this.props.search){
                query += `search=${this.props.search}&`;
            }
            axios.get(`/api/products/solrsearch?${encodeURI(query)}`)
                .then((products)=>{
                    const featuredProduct = products.data.response[0].result[0];

                    featuredProduct.id = featuredProduct.document_id;

                    this.fetchRelatingData(featuredProduct);

                }).catch((err)=>{
                    console.error(err);
                    this.setState({
                        isLoading: false
                    });
                });
        } else if (this.state.filterGroups) {
            query += `filterGroups=${JSON.stringify(this.state.filterGroups)}&`;

            axios.get(`/api/products?${query}`)
                .then((products)=>{
                    const featuredProduct = products.data.items[0];

                    this.fetchRelatingData(featuredProduct);

                }).catch((err)=>{
                    console.error(err);
                    this.setState({
                        isLoading: false
                    });
                });
        }
    }

    fetchRelatingData(featuredProduct){
        if(featuredProduct){
            axios.get(`/api/products/attributes/condition/options`)
                .then((conditionOptionsResult) =>{
                    let condition = conditionOptionsResult.data.find((option)=>{
                        return option.value == featuredProduct.condition;
                    });

                    featuredProduct.condition = condition.label;

                    if(featuredProduct.seller_id){
                        axios.get(`/api/sellers/${featuredProduct.seller_id}/shop`)
                            .then((sellerResult)=>{
                                this.setState({
                                    seller: {
                                        id: sellerResult.data.seller_id,
                                        name: sellerResult.data.shop_title,
                                        locality: sellerResult.data.company_locality,
                                        logo: sellerResult.data.logo_pic
                                    },
                                    product: {
                                        id: featuredProduct.id,
                                        name: featuredProduct.name,
                                        name_alt: featuredProduct.name_alt ? featuredProduct.name_alt : undefined,
                                        image: featuredProduct.image ,
                                        sku: featuredProduct.sku,
                                        condition: featuredProduct.condition,
                                        manufacturer_name: featuredProduct.manufacturer_name,
                                        model: featuredProduct.model,
                                        price: featuredProduct.price,
                                        quote_status: featuredProduct.quote_status,
                                        display_name_alt: featuredProduct.display_name_alt,
                                        is_in_stock: true
                                    },
                                    isLoading: false
                                });
                            }).catch((err)=>{
                                throw err;
                            });
                    } else  {
                        this.setState({
                            product: {
                                id: featuredProduct.id,
                                name: featuredProduct.name,
                                image: featuredProduct.image ,
                                sku: featuredProduct.sku,
                                condition: featuredProduct.condition,
                                manufacturer_name: featuredProduct.manufacturer_name,
                                model: featuredProduct.model,
                                price: featuredProduct.price,
                                quote_status: featuredProduct.quote_status,
                                display_name_alt: featuredProduct.display_name_alt,
                                is_in_stock: true
                            },
                            isLoading: false
                        });
                    }
                }).catch((err)=>{
                    throw err;
                });
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    componentDidMount(){
        this.fetchData();
    }
    render(){
        return(
            <div>
                {this.state.isLoading ? (
                    <div className="d-flex justify-content-center text-danger">
                        <i className="fas fa-spinner-third fa-3x fa-spin"></i>
                    </div>
                ) : (
                    this.state.product && (
                        <Item
                            title={this.props.title}
                            product={this.state.product}
                            seller={this.state.seller}
                            countries={this.props.countries}
                        />
                    )
                )}
            </div>
        );
    }
}

BuyBoxWidget.defaultProps = {
    filters: {},
    filterGroups: [],
    search: null
};

BuyBoxWidget.propTypes = {
    title: PropTypes.string,
    filters: PropTypes.object,
    filterGroups: PropTypes.array,
    countries: PropTypes.object,
    search: PropTypes.string
};

export {BuyBoxWidget};
